// Self-hosted polyfills (replaces the removed polyfill.io CDN script).
// core-js provides ECMAScript feature polyfills for older browsers,
// regenerator-runtime supports transpiled async/await & generators.
import 'core-js/stable';
import 'regenerator-runtime/runtime';
